import React from 'react';
import { StepIconProps } from '@mui/material';

import { StyledIcon } from './CustomStepIcon.styled';

const CustomStepIcon: React.FC<StepIconProps> = ({ active, completed, icon, error }) => (
  <StyledIcon ownerState={{ active, completed, error }}>{icon}</StyledIcon>
);

export default CustomStepIcon;
